module.exports = __webpack_public_path__ + "static/img/1.d3e292c.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/notice/1.png
// module id = um/w
// module chunks = 1